<template>
  <div
    v-for="(field, index) in filteredFields"
    :key="`field-${index}`"
    class="hr-field-view"
    data-testid="super-field-view"
  >
    <span class="hr-field-view__title" data-testid="super-field-title">{{
      t(`tax-and-super:${field.labelTranslationKey}`)
    }}</span
    ><span
      class="hr-field-view__value fs-mask"
      data-testid="super-field-value"
      >{{ field.value }}</span
    >
  </div>
</template>

<script>
import t from '@/lib/i18next';
import { computed } from 'vue';
import {
  MAPPER_KEY,
  SUPER_TYPE_KEYS,
  SUPER_TYPE_LABEL_MAP,
  YES_NO_LABEL_MAP,
} from '@/core/documents/au/superstep-constants';

export default {
  name: 'hr-super-fields-view',
  props: {
    fields: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const PENDING_MEMBER_NUMBER_MESSAGE = t(
      'tax-and-super:pending-member-number'
    );
    const filteredFields = computed(() => {
      const isSelfManaged =
        props.fields[MAPPER_KEY.SUPER_TYPE]?.value ===
        SUPER_TYPE_LABEL_MAP[SUPER_TYPE_KEYS.SELF_MANAGED];

      // Filter out duplicate fields
      const fieldsToIgnore = [
        MAPPER_KEY.SUPER_DECLARE_TRUE_AND_CORRECT,
        MAPPER_KEY.SUPER_TFN_NUMBER,
        MAPPER_KEY.SUPER_NAME,
      ];

      return Object.entries(props.fields).reduce((acc, [key, field]) => {
        if (fieldsToIgnore.includes(key)) return acc;

        let value = field.value;

        const shouldShowPendingMemberNumber =
          key === MAPPER_KEY.SUPER_FUND_MEMBER &&
          !field.value &&
          !isSelfManaged &&
          props.fields[MAPPER_KEY.SUPER_OPTION]?.value === YES_NO_LABEL_MAP.Yes;

        if (shouldShowPendingMemberNumber) {
          value = PENDING_MEMBER_NUMBER_MESSAGE;
        }

        if (value) {
          acc.push({
            labelTranslationKey: field.labelTranslationKey,
            value,
          });
        }

        return acc;
      }, []);
    });

    return {
      t,
      filteredFields,
    };
  },
};
</script>
